const RainBackground = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden">
      {/* Static gradient background - animations removed for CPU performance */}
      <div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(circle at 50% 50%, rgba(123, 123, 255, 0.15) 0%, transparent 70%),
            radial-gradient(circle at 80% 20%, rgba(123, 255, 255, 0.18) 0%, transparent 50%),
            radial-gradient(circle at 20% 80%, rgba(212, 175, 55, 0.18) 0%, transparent 50%)
          `,
        }}
      />
    </div>
  );
};

export default RainBackground;
